<template>
  <div>
    <HEADER></HEADER>
    <!-- <div class="nc_about_header">
      <div class="banner">
        <img src="../assets/img/partner/nc_school.png" alt />
      </div>
      <div class="w">
        <div class="about_content">
          <h1>关于我们</h1>
          <p>nCompass让数据流量更简单</p>
        </div>
      </div>
    </div> -->
    <BANNER :src="banner_bg" h1='关于我们'  >
      <p>专注于通过流量大数据+智能算法解决网络应用故障及安全的公司（Traffic Data Analysis）</p>
      <!-- <p>解决网络应用故障及安全的公司</p> -->
    </BANNER>
    <div class="about_main">
      <div class="w">
        <div class="comp_introduce">
          <!-- <p class="ncmp">nCompass独创了流数据采集，策略检索，AI算法，知识图谱，可视化一体化平台，是国内第一家实现流量数据源采集分析的大数据公司。</p>
          <p class="ncmp">与日志大数据技术改变了企业利用机器数据的方式一样，流量数据是一直存在的而且稍纵即逝，但由于其实时实性和丰富性，其价值远远没有被挖掘，nCompass通过其独创的流数据分析平台让用户更加轻松的根据需要进行消费。</p>
          <p class="ncmp">Ncompass的数据分析平台的使用对智能运维、安全、BI数据分析等领域产生技术性变革的影响。</p>
          <p class="ncmp">与传统封闭、后置、定制化的数据分析系统不同，nCompass从底层构建了开放的实时同频的数据源分析平台。平台提供了丰富API接口方便用户更轻松的洞见数据的异常与趋势。该能力已经被全球领导厂商和各行业头部认可并完成数据对接与合作，服务于运营商，金融、政企，互联网等多领域和行业中，得到客户的一致认可。</p> -->
          <!--<p class="ncmp">智维数据，全称是北京智维盈讯网络科技有限公司，成立于2015年，是立足于中国本土的智能运维大数据公司，通过布局关键数据节点，为服务企业快速建立业务交互数据地图和完整的监控视角，提供安全、高效、可观测性强的运维管理及安全响应解决方案。</p>
          <p class="ncmp" style="margin-top:20px;">公司的系列产品通过机器学习及缝合算法自动绘制企业实时业务交互数据动态地图，利用独有的智能算法自动发现数据异常，提升用户在IT网络运维及安全上的响应能力，改变企业IT监控与业务相脱离的现状。智维数据是业内此类技术的领跑者，能够提供全访问流程监控与分析产品的公司，为未来场景算法提供更强的可扩展空间。</p>-->
          <p class="ncmp" style="wordBreak:break-all">智维数据，全称是北京智维盈讯网络科技有限公司，成立于2015年，是立足于中国本土的智能运维大数据公司，通过布局关键数据节点，为服务企业快速建立业务交互数据地图和完整的监控视角，提供安全、高效、可观测性强的运维管理及安全响应解决方案。公司的系列产品通过机器学习及缝合算法自动绘制企业实时业务交互数据动态地图，利用独有的智能算法自动发现数据异常，提升用户在IT网络运维及安全上的响应能力，改变企业IT监控与业务相脱离的现状。智维数据是业内此类技术的领跑者，为用户提供全访问流程监控与分析产品，支撑未来场景算法拥有更强的可扩展空间。</p>
          <ul class="address">
            <li>
              <p><i class="iconfont icon-dingwei"></i>北京总部</p>
              <p>北京市朝阳区八里庄西里99号</p>
              <p>住邦2000二号楼807</p>
              <p>400-666-8216</p>
            </li>
             <li>
              <p><i class="iconfont icon-dingwei"></i>上海</p>
              <p>上海市静安区大宁中心广场三期</p>
              <p>灵石路718号A7202</p>
              <p>400-666-8216</p>
            </li>
            <li>
              <p><i class="iconfont icon-dingwei"></i>深圳</p>
              <p>深圳市南山区高新科技园南</p>
              <p>十二路九洲电器大厦B座3层F室</p>
              <p>400-666-8216</p>
            </li>
            <li>
              <p><i class="iconfont icon-dingwei"></i>廊坊</p>
              <p>河北省廊坊市三河市燕郊镇神威北大街</p>
              <p>岩峰大厦1110室</p>
              <p>400-666-8216</p>
            </li>
            <li>
              <p><i class="iconfont icon-dingwei"></i>合肥</p>
              <p>合肥市长江中路436号</p>
              <p>金城大厦14楼</p>
              <p>0551-63800810</p>
            </li>
             <li>
              <p><i class="iconfont icon-dingwei"></i>郑州</p>
              <p>郑州市经三路68号</p>
              <p>2号楼18层</p>
              <p>0371-69508188</p>
            </li>
            <li>
              <p><i class="iconfont icon-dingwei"></i>西安</p>
              <p>西安市高新区丈八四路20号</p>
              <p>神州数码西安科技园1号楼</p>
              <p>029-88342300</p>
            </li>
            <li>
              <p><i class="iconfont icon-dingwei"></i>成都</p>
              <p>成都市光耀大厦B726室  </p>
              <p></p>
              <p>400-666-8216</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="line"></div>
      <div class="w">
        <div class="service">
            <h3>合作服务</h3>
            <div class="contact">
              <div class="mail">
                <img src="../assets/img/about/mail.svg" alt />
                <div class="right">
                  <p>技术支持</p>
                  <p>support@ncmps.com</p>
                </div>
              </div>
              <div class="phone">
                <img src="../assets/img/about/phone.svg" alt />
                <div class="right">
                  <p>全国免费客户服务热线</p>
                  <p>400-666-8216</p>
                </div>
              </div>
              <div class="market">
                <img src="../assets/img/about/market.svg" alt />
                <div class="right">
                  <p>市场或渠道合作</p>
                  <p>partner@ncmps.com</p>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <WHO></WHO>
    <FOOTER></FOOTER>
  </div>
</template>

<script>
import HEADER from "../components/header.vue";
import FOOTER from "../components/footer.vue";
import WHO from "../components/who.vue";
import '../assets/iconfonts/iconfont.css';
import BANNER from "../components/banner.vue";
import banner_bg from '../assets/img/about/nc_about.jpg';
export default {
  components: {
    HEADER,
    FOOTER,
    WHO,
    BANNER
  },
  data() {
    return {
      banner_bg:banner_bg
    };
  },
};
</script>

<style lang='less'>
@import url("../assets/css/about.less");
</style>